import { render, staticRenderFns } from "./Piatto.vue?vue&type=template&id=c56d2e68"
import script from "./Piatto.vue?vue&type=script&lang=js"
export * from "./Piatto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports